// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as Belt_Id from "@rescript/runtime/lib/es6/Belt_Id.js";
import * as LumiJzon from "lumi-rescript/lib/es6/src/LumiJzon.res.js";
import * as Stdlib_Int from "@rescript/runtime/lib/es6/Stdlib_Int.js";
import * as FontAwesome$Web from "lumi-web/lib/es6/src/FontAwesome.res.js";
import * as Primitive_object from "@rescript/runtime/lib/es6/Primitive_object.js";
import * as JsxRuntime from "react/jsx-runtime";

let Namespace = {
  jsonCodec: Jzon.int
};

let GroupId = {
  jsonCodec: Jzon.int
};

let SensorId = {
  jsonCodec: Jzon.int
};

function toString(param) {
  return param[0].toString() + "," + param[1].toString();
}

function fromString(str) {
  let parts = str.split(",", 2).map(none => Stdlib_Int.fromString(none, 10));
  if (parts.length !== 2) {
    return {
      TAG: "Error",
      _0: "invalid groupFullId: " + str
    };
  }
  let namespace = parts[0];
  if (namespace === undefined) {
    return {
      TAG: "Error",
      _0: "invalid groupFullId: " + str
    };
  }
  let group = parts[1];
  if (group !== undefined) {
    return {
      TAG: "Ok",
      _0: [
        namespace,
        group
      ]
    };
  } else {
    return {
      TAG: "Error",
      _0: "invalid groupFullId: " + str
    };
  }
}

function cmp(param, param$1) {
  let c = Primitive_object.compare(param[0], param$1[0]);
  if (c !== 0) {
    return c;
  } else {
    return Primitive_object.compare(param[1], param$1[1]);
  }
}

let Cmp = Belt_Id.MakeComparable({
  cmp: cmp
});

let jsonCodec = LumiJzon.tuple2(Jzon.int, Jzon.int);

function SensorGroups$GroupFullId(props) {
  let match = props.groupFullId;
  return JsxRuntime.jsxs("span", {
    children: [
      JsxRuntime.jsx("span", {
        children: JsxRuntime.jsx(FontAwesome$Web.Solid.make, {
          name: "database"
        }),
        className: "tag is-dark"
      }),
      JsxRuntime.jsx("span", {
        children: `(` + match[0].toString() + `, ` + match[1].toString() + `)`,
        className: "tag is-light is-text"
      })
    ],
    className: "tags has-addons"
  });
}

let GroupFullId = {
  toString: toString,
  fromString: fromString,
  Cmp: Cmp,
  jsonCodec: jsonCodec,
  make: SensorGroups$GroupFullId
};

function toString$1(param) {
  return param[0].toString() + "," + param[1].toString();
}

function fromString$1(str) {
  let parts = str.split(",", 2).map(none => Stdlib_Int.fromString(none, 10));
  if (parts.length !== 2) {
    return {
      TAG: "Error",
      _0: "invalid sensorFullId: " + str
    };
  }
  let namespace = parts[0];
  if (namespace === undefined) {
    return {
      TAG: "Error",
      _0: "invalid sensorFullId: " + str
    };
  }
  let group = parts[1];
  if (group !== undefined) {
    return {
      TAG: "Ok",
      _0: [
        namespace,
        group
      ]
    };
  } else {
    return {
      TAG: "Error",
      _0: "invalid sensorFullId: " + str
    };
  }
}

function cmp$1(param, param$1) {
  let c = Primitive_object.compare(param[0], param$1[0]);
  if (c !== 0) {
    return c;
  } else {
    return Primitive_object.compare(param[1], param$1[1]);
  }
}

let Cmp$1 = Belt_Id.MakeComparable({
  cmp: cmp$1
});

let jsonCodec$1 = LumiJzon.tuple2(Jzon.int, Jzon.int);

let SensorFullId_dummy = [
  -1,
  -1
];

let SensorFullId = {
  dummy: SensorFullId_dummy,
  toString: toString$1,
  fromString: fromString$1,
  Cmp: Cmp$1,
  jsonCodec: jsonCodec$1
};

export {
  Namespace,
  GroupId,
  SensorId,
  GroupFullId,
  SensorFullId,
}
/* Cmp Not a pure module */
